import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyle = makeStyles(() => ({
  descriptionText: {
    fontSize: 15,
    fontWeight: 500,
  },
  valueText: {
    color: '#4A4B4E',
    fontSize: 17,
    fontWeight: 400,
  },
}));

type CoverageDetailProps = {
  code: string;
  name: string;
  value: string;
};

const CoverageDetailRow = ({
  code,
  name,
  value,
}: CoverageDetailProps): JSX.Element => {
  const classes = useStyle();
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      data-testid={`coverages-${code}`}
      style={{ gap: '0.5rem' }}
    >
      <Typography
        className={classes.descriptionText}
        data-testid="coverage-name"
      >
        {name}
      </Typography>
      <Typography className={classes.valueText} data-testid="coverage-value">
        {value}
      </Typography>
    </Box>
  );
};

export default CoverageDetailRow;
